import {emptyParametros, ParametrosVo} from '~model/vo/parametros-vo';
import {EntityIndicador} from '~entity/entity-indicador/entity-indicador.model';
import {emptyTiposIncidentes, TiposIncidentesVo} from '~model/vo/tipos-incidentes-vo';

export interface EntityConfiguracao extends EntityConfiguracaoBase{
  configIndicadores: { indicadores: { [key: string]: EntityIndicador } };
  tiposIncidentes: TiposIncidentesVo;
  defaultLocation: [number, number];
}

export interface EntityConfiguracaoBase {
  id: string;
  camposVisiveis: string[];
  camposGrid?: string[];
  filtrosVisiveis: string[];
  personalizarFiltros?: boolean;
  listaIntegracoes?: string[];
  idioma: string;
  tema?: string;
  mostrarIndicadores: boolean;
  utilizaGrupoUsuario: boolean,
  parametros: ParametrosVo;
}

export const entityConfigVoid = (): EntityConfiguracao => ({
  id: '',
  defaultLocation: [-47.165451, -22.847815],
  camposVisiveis: [],
  camposGrid: [],
  filtrosVisiveis: [],
  idioma: 'pt-BR',
  mostrarIndicadores: false,
  utilizaGrupoUsuario: false,
  parametros: emptyParametros(),
  configIndicadores: {indicadores: {}},
  tiposIncidentes: emptyTiposIncidentes(),
});
